<template>
  <div class="blog-reactions d-flex align-center ga-2 flex-wrap">
    <v-menu
      v-for="r in reactionTypes"
      :key="r.type"
      open-on-hover
      :open-delay="300"
      :close-delay="100"
      location="top"
      :disabled="!reactors[r.type] || reactors[r.type].length === 0"
    >
      <template #activator="{ props: menuProps }">
        <v-btn
          v-bind="menuProps"
          :variant="userReaction === r.type ? 'flat' : 'outlined'"
          :color="userReaction === r.type ? r.color : 'grey'"
          size="small"
          class="reaction-btn"
          @click="$emit('react', r.type)"
        >
          <span class="mr-1">{{ r.emoji }}</span>
          {{ reactions[r.type] || 0 }}
        </v-btn>
      </template>

      <v-card class="reactors-card pa-2" min-width="160" max-width="240">
        <div class="reactors-title text-caption font-weight-bold mb-1">
          {{ r.emoji }} {{ getReactionLabel(r.type) }}
        </div>
        <div
          v-for="user in reactors[r.type]"
          :key="user.userId"
          class="reactor-item d-flex align-center ga-2 py-1"
        >
          <v-avatar size="22">
            <v-img v-if="user.avatarUrl" :src="user.avatarUrl" />
            <v-icon v-else size="18">mdi-account-circle</v-icon>
          </v-avatar>
          <span class="text-body-2">{{ user.displayName || user.username }}</span>
        </div>
      </v-card>
    </v-menu>

    <v-spacer />

    <span class="text-caption text-grey">
      {{ total }} {{ $t('blog.reactionsTotal') }}
    </span>
  </div>
</template>

<script setup>
/* eslint-disable */
import { ref, watch, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import api from '../../services/api'

const { t } = useI18n()

const props = defineProps({
  postId: { type: Number, required: true },
  reactions: { type: Object, default: () => ({}) },
  userReaction: { type: String, default: null },
  total: { type: Number, default: 0 }
})

defineEmits(['react'])

const reactionTypes = [
  { type: 'like', emoji: '👍', color: 'blue' },
  { type: 'love', emoji: '❤️', color: 'red' },
  { type: 'insightful', emoji: '💡', color: 'amber-darken-2' },
  { type: 'disagree', emoji: '🤔', color: 'orange' },
  { type: 'funny', emoji: '😂', color: 'green' }
]

const reactors = ref({})

const getReactionLabel = (type) => {
  const labels = {
    like: t('blog.reactionLike', 'Synes godt om'),
    love: t('blog.reactionLove', 'Elsker'),
    insightful: t('blog.reactionInsightful', 'Indsigtsfuld'),
    disagree: t('blog.reactionDisagree', 'Uenig'),
    funny: t('blog.reactionFunny', 'Sjov'),
  }
  return labels[type] || type
}

const fetchReactors = async () => {
  if (!props.postId || props.total === 0) {
    reactors.value = {}
    return
  }

  try {
    const { data } = await api.get(`/blog/${props.postId}/reactions`)
    reactors.value = data.reactions || {}
  } catch (error) {
    console.error('Error fetching reactors:', error)
  }
}

// Refresh reactors when total changes (after a reaction toggle)
watch(() => props.total, () => {
  fetchReactors()
})

onMounted(() => {
  fetchReactors()
})
</script>

<style scoped>
.reaction-btn {
  min-width: 52px;
  text-transform: none;
}

.reactors-card {
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
}

.reactors-title {
  color: #555;
  border-bottom: 1px solid #eee;
  padding-bottom: 4px;
  margin-bottom: 4px;
}

.reactor-item {
  border-radius: 4px;
  padding: 2px 4px;
}

.reactor-item:hover {
  background: #f5f5f5;
}
</style>